import { useEffect, useState } from 'react'

type AppsFlyerUrl = { clickURL: string }

const useAppsFlyer = () => {
  const [generatedUrl, setGeneratedUrl] = useState<AppsFlyerUrl>({
    clickURL: 'https://freedomworld.onelink.me/P3wD/wobd64gh',
  })
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const generateUrl = () => {
      try {
        if (window.AF_SMART_SCRIPT) {
          const config = {
            oneLinkURL: 'https://freedomworld.onelink.me/P3wD/wobd64gh',
            afParameters: {
              mediaSource: {
                keys: ['utm_source', 'af_media_source'],
                defaultValue: 'any_source',
              },
              campaign: { keys: ['utm_campaign', 'af_campaign'] },
              channel: { keys: ['utm_medium'] },
              deepLinkValue: { defaultValue: 'auto_switch' },
              afCustom: [
                { paramKey: 'af_xp', defaultValue: 'custom' },
                { paramKey: 'af_force_deeplink', defaultValue: 'true' },
                { paramKey: 'af_ss_ui', defaultValue: 'true' },
              ],
              adSet: { keys: ['utm_content'] },
              ad: { keys: ['utm_term'] },
            },
          }

          const result: unknown = window.AF_SMART_SCRIPT.generateOneLinkURL(config)
          if (typeof result === 'string') {
            setGeneratedUrl({ clickURL: result })
          } else if (
            result &&
            typeof result === 'object' &&
            'clickURL' in result &&
            typeof (result as { clickURL?: unknown }).clickURL === 'string'
          ) {
            setGeneratedUrl({ clickURL: (result as { clickURL: string }).clickURL })
          }
        }
      } catch (error) {
        console.error('Error generating AppsFlyer URL:', error)
      } finally {
        setIsLoading(false)
      }
    }

    if (window.AF_SMART_SCRIPT) {
      generateUrl()
      return
    }

    const script = document.createElement('script')
    script.src =
      'https://onelinksmartscript.appsflyer.com/onelink-smart-script-latest.js'
    script.async = true

    script.onload = generateUrl
    script.onerror = () => {
      console.error('Failed to load AppsFlyer script')
      setIsLoading(false)
    }

    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return { generatedUrl, isLoading }
}

export default useAppsFlyer
